export const phoneNumbers = [
    { countryCode: "AF", dialCode: "+93", length: 9 },
    { countryCode: "AL", dialCode: "+355", length: 9 },
    { countryCode: "DZ", dialCode: "+213", length: 9 },
    { countryCode: "AS", dialCode: "+1684", length: 10 },
    { countryCode: "AD", dialCode: "+376", length: 6 },
    { countryCode: "AO", dialCode: "+244", length: 9 },
    { countryCode: "AI", dialCode: "+1264", length: 10 },
    { countryCode: "AQ", dialCode: "+672", length: 9 },
    { countryCode: "AG", dialCode: "+1268", length: 10 },
    { countryCode: "AR", dialCode: "+54", length: 10 },
    { countryCode: "AM", dialCode: "+374", length: 8 },
    { countryCode: "AW", dialCode: "+297", length: 7 },
    { countryCode: "AU", dialCode: "+61", length: 9 },
    { countryCode: "AT", dialCode: "+43", length: 10 },
    { countryCode: "AZ", dialCode: "+994", length: 9 },
    { countryCode: "BS", dialCode: "+1242", length: 10 },
    { countryCode: "BH", dialCode: "+973", length: 8 },
    { countryCode: "BD", dialCode: "+880", length: 10 },
    { countryCode: "BB", dialCode: "+1246", length: 10 },
    { countryCode: "BY", dialCode: "+375", length: 9 },
    { countryCode: "BE", dialCode: "+32", length: 9 },
    { countryCode: "BZ", dialCode: "+501", length: 7 },
    { countryCode: "BJ", dialCode: "+229", length: 9 },
    { countryCode: "BM", dialCode: "+1441", length: 10 },
    { countryCode: "BT", dialCode: "+975", length: 8 },
    { countryCode: "BO", dialCode: "+591", length: 8 },
    { countryCode: "BA", dialCode: "+387", length: 8 },
    { countryCode: "BW", dialCode: "+267", length: 7 },
    { countryCode: "BR", dialCode: "+55", length: 11 },
    { countryCode: "BN", dialCode: "+673", length: 7 },
    { countryCode: "BG", dialCode: "+359", length: 9 },
    { countryCode: "BF", dialCode: "+226", length: 8 },
    { countryCode: "BI", dialCode: "+257", length: 8 },
    { countryCode: "KH", dialCode: "+855", length: 9 },
    { countryCode: "CM", dialCode: "+237", length: 9 },
    { countryCode: "CA", dialCode: "+1", length: 10 },
    { countryCode: "CV", dialCode: "+238", length: 7 },
    { countryCode: "KY", dialCode: "+1345", length: 10 },
    { countryCode: "CF", dialCode: "+236", length: 8 },
    { countryCode: "TD", dialCode: "+235", length: 8 },
    { countryCode: "CL", dialCode: "+56", length: 9 },
    { countryCode: "CN", dialCode: "+86", length: 11 },
    { countryCode: "CO", dialCode: "+57", length: 10 },
    { countryCode: "KM", dialCode: "+269", length: 7 },
    { countryCode: "CG", dialCode: "+242", length: 9 },
    { countryCode: "CD", dialCode: "+243", length: 9 },
    { countryCode: "CR", dialCode: "+506", length: 8 },
    { countryCode: "HR", dialCode: "+385", length: 9 },
    { countryCode: "CU", dialCode: "+53", length: 8 },
    { countryCode: "CY", dialCode: "+357", length: 8 },
    { countryCode: "CZ", dialCode: "+420", length: 9 },
    { countryCode: "DK", dialCode: "+45", length: 8 },
    { countryCode: "DJ", dialCode: "+253", length: 6 },
    { countryCode: "DM", dialCode: "+1767", length: 10 },
    { countryCode: "DO", dialCode: "+1", length: 10 },
    { countryCode: "EC", dialCode: "+593", length: 9 },
    { countryCode: "EG", dialCode: "+20", length: 10 },
    { countryCode: "SV", dialCode: "+503", length: 8 },
    { countryCode: "GQ", dialCode: "+240", length: 9 },
    { countryCode: "ER", dialCode: "+291", length: 7 },
    { countryCode: "EE", dialCode: "+372", length: 8 },
    { countryCode: "SZ", dialCode: "+268", length: 7 },
    { countryCode: "ET", dialCode: "+251", length: 9 },
    { countryCode: "FJ", dialCode: "+679", length: 7 },
    { countryCode: "FI", dialCode: "+358", length: 9 },
    { countryCode: "FR", dialCode: "+33", length: 9 },
    { countryCode: "GA", dialCode: "+241", length: 7 },
    { countryCode: "GM", dialCode: "+220", length: 7 },
    { countryCode: "GE", dialCode: "+995", length: 9 },
    { countryCode: "DE", dialCode: "+49", length: 10 },
    { countryCode: "GH", dialCode: "+233", length: 9 },
    { countryCode: "GR", dialCode: "+30", length: 10 },
    { countryCode: "GD", dialCode: "+1473", length: 10 },
    { countryCode: "GT", dialCode: "+502", length: 8 },
    { countryCode: "GN", dialCode: "+224", length: 9 },
    { countryCode: "GW", dialCode: "+245", length: 9 },
    { countryCode: "GY", dialCode: "+592", length: 7 },
    { countryCode: "HT", dialCode: "+509", length: 8 },
    { countryCode: "HN", dialCode: "+504", length: 8 },
    { countryCode: "HU", dialCode: "+36", length: 9 },
    { countryCode: "IS", dialCode: "+354", length: 7 },
    { countryCode: "IN", dialCode: "+91", length: 10 },
    { countryCode: "ID", dialCode: "+62", length: 10 },
    { countryCode: "IR", dialCode: "+98", length: 10 },
    { countryCode: "IQ", dialCode: "+964", length: 10 },
    { countryCode: "IE", dialCode: "+353", length: 9 },
    { countryCode: "IL", dialCode: "+972", length: 9 },
    { countryCode: "IT", dialCode: "+39", length: 10 },
    { countryCode: "CI", dialCode: "+225", length: 8 },
    { countryCode: "JM", dialCode: "+1876", length: 10 },
    { countryCode: "JP", dialCode: "+81", length: 10 },
    { countryCode: "JO", dialCode: "+962", length: 9 },
    { countryCode: "KZ", dialCode: "+7", length: 10 },
    { countryCode: "KE", dialCode: "+254", length: 9 },
    { countryCode: "KI", dialCode: "+686", length: 5 },
    { countryCode: "KP", dialCode: "+850", length: 10 },
    { countryCode: "KR", dialCode: "+82", length: 10 },
    { countryCode: "KW", dialCode: "+965", length: 8 },
    { countryCode: "KG", dialCode: "+996", length: 9 },
    { countryCode: "LA", dialCode: "+856", length: 9 },
    { countryCode: "LV", dialCode: "+371", length: 8 },
    { countryCode: "LB", dialCode: "+961", length: 8 },
    { countryCode: "LS", dialCode: "+266", length: 8 },
    { countryCode: "LR", dialCode: "+231", length: 7 },
    { countryCode: "LY", dialCode: "+218", length: 9 },
    { countryCode: "LI", dialCode: "+423", length: 7 },
    { countryCode: "LT", dialCode: "+370", length: 8 },
    { countryCode: "LU", dialCode: "+352", length: 9 },
    { countryCode: "MG", dialCode: "+261", length: 9 },
    { countryCode: "MW", dialCode: "+265", length: 9 },
    { countryCode: "MY", dialCode: "+60", length: 10 },
    { countryCode: "MV", dialCode: "+960", length: 7 },
    { countryCode: "ML", dialCode: "+223", length: 8 },
    { countryCode: "MT", dialCode: "+356", length: 8 },
    { countryCode: "MH", dialCode: "+692", length: 7 },
    { countryCode: "MR", dialCode: "+222", length: 9 },
    { countryCode: "MU", dialCode: "+230", length: 7 },
    { countryCode: "MX", dialCode: "+52", length: 10 },
    { countryCode: "FM", dialCode: "+691", length: 7 },
    { countryCode: "MD", dialCode: "+373", length: 8 },
    { countryCode: "MC", dialCode: "+377", length: 9 },
    { countryCode: "MN", dialCode: "+976", length: 8 },
    { countryCode: "ME", dialCode: "+382", length: 8 },
    { countryCode: "MA", dialCode: "+212", length: 9 },
    { countryCode: "MZ", dialCode: "+258", length: 9 },
    { countryCode: "MM", dialCode: "+95", length: 9 },
    { countryCode: "NA", dialCode: "+264", length: 9 },
    { countryCode: "NR", dialCode: "+674", length: 7 },
    { countryCode: "NP", dialCode: "+977", length: 10 },
    { countryCode: "NL", dialCode: "+31", length: 9 },
    { countryCode: "NZ", dialCode: "+64", length: 9 },
    { countryCode: "NI", dialCode: "+505", length: 8 },
    { countryCode: "NE", dialCode: "+227", length: 8 },
    { countryCode: "NG", dialCode: "+234", length: 10 },
    { countryCode: "NO", dialCode: "+47", length: 8 },
    { countryCode: "OM", dialCode: "+968", length: 8 },
    { countryCode: "PK", dialCode: "+92", length: 10 },
    { countryCode: "PW", dialCode: "+680", length: 7 },
    { countryCode: "PA", dialCode: "+507", length: 8 },
    { countryCode: "PG", dialCode: "+675", length: 8 },
    { countryCode: "PY", dialCode: "+595", length: 9 },
    { countryCode: "PE", dialCode: "+51", length: 9 },
    { countryCode: "PH", dialCode: "+63", length: 10 },
    { countryCode: "PL", dialCode: "+48", length: 9 },
    { countryCode: "PT", dialCode: "+351", length: 9 },
    { countryCode: "QA", dialCode: "+974", length: 8 },
    { countryCode: "RO", dialCode: "+40", length: 10 },
    { countryCode: "RU", dialCode: "+7", length: 10 },
    { countryCode: "RW", dialCode: "+250", length: 9 },
    { countryCode: "KN", dialCode: "+1869", length: 10 },
    { countryCode: "LC", dialCode: "+1758", length: 10 },
    { countryCode: "VC", dialCode: "+1784", length: 10 },
    { countryCode: "WS", dialCode: "+685", length: 7 },
    { countryCode: "SM", dialCode: "+378", length: 9 },
    { countryCode: "ST", dialCode: "+239", length: 7 },
    { countryCode: "SA", dialCode: "+966", length: 9 },
    { countryCode: "SN", dialCode: "+221", length: 9 },
    { countryCode: "RS", dialCode: "+381", length: 9 },
    { countryCode: "SC", dialCode: "+248", length: 7 },
    { countryCode: "SL", dialCode: "+232", length: 8 },
    { countryCode: "SG", dialCode: "+65", length: 8 },
    { countryCode: "SK", dialCode: "+421", length: 9 },
    { countryCode: "SI", dialCode: "+386", length: 9 },
    { countryCode: "SB", dialCode: "+677", length: 7 },
    { countryCode: "SO", dialCode: "+252", length: 9 },
    { countryCode: "ZA", dialCode: "+27", length: 9 },
    { countryCode: "ES", dialCode: "+34", length: 9 },
    { countryCode: "LK", dialCode: "+94", length: 9 },
    { countryCode: "SD", dialCode: "+249", length: 9 },
    { countryCode: "SR", dialCode: "+597", length: 7 },
    { countryCode: "SE", dialCode: "+46", length: 9 },
    { countryCode: "CH", dialCode: "+41", length: 9 },
    { countryCode: "SY", dialCode: "+963", length: 9 },
    { countryCode: "TW", dialCode: "+886", length: 9 },
    { countryCode: "TJ", dialCode: "+992", length: 9 },
    { countryCode: "TZ", dialCode: "+255", length: 9 },
    { countryCode: "TH", dialCode: "+66", length: 9 },
    { countryCode: "TL", dialCode: "+670", length: 7 },
    { countryCode: "TG", dialCode: "+228", length: 8 },
    { countryCode: "TO", dialCode: "+676", length: 5 },
    { countryCode: "TT", dialCode: "+1868", length: 10 },
    { countryCode: "TN", dialCode: "+216", length: 8 },
    { countryCode: "TR", dialCode: "+90", length: 10 },
    { countryCode: "TM", dialCode: "+993", length: 8 },
    { countryCode: "TV", dialCode: "+688", length: 6 },
    { countryCode: "UG", dialCode: "+256", length: 9 },
    { countryCode: "UA", dialCode: "+380", length: 9 },
    { countryCode: "AE", dialCode: "+971", length: 9 },
    { countryCode: "GB", dialCode: "+44", length: 10 },
    { countryCode: "US", dialCode: "+1", length: 10 },
    { countryCode: "UY", dialCode: "+598", length: 9 },
    { countryCode: "UZ", dialCode: "+998", length: 9 },
    { countryCode: "VU", dialCode: "+678", length: 7 },
    { countryCode: "VA", dialCode: "+379", length: 9 },
    { countryCode: "VE", dialCode: "+58", length: 10 },
    { countryCode: "VN", dialCode: "+84", length: 10 },
    { countryCode: "YE", dialCode: "+967", length: 9 },
    { countryCode: "ZM", dialCode: "+260", length: 9 },
    { countryCode: "ZW", dialCode: "+263", length: 9 }
];

export const countryCodeList = [
    {
        "countryCode": "BD",
        "dialCode": "+880"
    },
    {
        "countryCode": "BE",
        "dialCode": "+32"
    },
    {
        "countryCode": "BF",
        "dialCode": "+226"
    },
    {
        "countryCode": "BG",
        "dialCode": "+359"
    },
    {
        "countryCode": "BA",
        "dialCode": "+387"
    },
    {
        "countryCode": "BB",
        "dialCode": "+1-246"
    },
    {
        "countryCode": "WF",
        "dialCode": "+681"
    },
    {
        "countryCode": "BL",
        "dialCode": "+590"
    },
    {
        "countryCode": "BM",
        "dialCode": "+1-441"
    },
    {
        "countryCode": "BN",
        "dialCode": "+673"
    },
    {
        "countryCode": "BO",
        "dialCode": "+591"
    },
    {
        "countryCode": "BH",
        "dialCode": "+973"
    },
    {
        "countryCode": "BI",
        "dialCode": "+257"
    },
    {
        "countryCode": "BJ",
        "dialCode": "+229"
    },
    {
        "countryCode": "BT",
        "dialCode": "+975"
    },
    {
        "countryCode": "JM",
        "dialCode": "+1-876"
    },
    {
        "countryCode": "BV",
        "dialCode": "+"
    },
    {
        "countryCode": "BW",
        "dialCode": "+267"
    },
    {
        "countryCode": "WS",
        "dialCode": "+685"
    },
    {
        "countryCode": "BQ",
        "dialCode": "+599"
    },
    {
        "countryCode": "BR",
        "dialCode": "+55"
    },
    {
        "countryCode": "BS",
        "dialCode": "+1-242"
    },
    {
        "countryCode": "JE",
        "dialCode": "+44-1534"
    },
    {
        "countryCode": "BY",
        "dialCode": "+375"
    },
    {
        "countryCode": "BZ",
        "dialCode": "+501"
    },
    {
        "countryCode": "RU",
        "dialCode": "+7"
    },
    {
        "countryCode": "RW",
        "dialCode": "+250"
    },
    {
        "countryCode": "RS",
        "dialCode": "+381"
    },
    {
        "countryCode": "TL",
        "dialCode": "+670"
    },
    {
        "countryCode": "RE",
        "dialCode": "+262"
    },
    {
        "countryCode": "TM",
        "dialCode": "+993"
    },
    {
        "countryCode": "TJ",
        "dialCode": "+992"
    },
    {
        "countryCode": "RO",
        "dialCode": "+40"
    },
    {
        "countryCode": "TK",
        "dialCode": "+690"
    },
    {
        "countryCode": "GW",
        "dialCode": "+245"
    },
    {
        "countryCode": "GU",
        "dialCode": "+1-671"
    },
    {
        "countryCode": "GT",
        "dialCode": "+502"
    },
    {
        "countryCode": "GS",
        "dialCode": "+"
    },
    {
        "countryCode": "GR",
        "dialCode": "+30"
    },
    {
        "countryCode": "GQ",
        "dialCode": "+240"
    },
    {
        "countryCode": "GP",
        "dialCode": "+590"
    },
    {
        "countryCode": "JP",
        "dialCode": "+81"
    },
    {
        "countryCode": "GY",
        "dialCode": "+592"
    },
    {
        "countryCode": "GG",
        "dialCode": "+44-1481"
    },
    {
        "countryCode": "GF",
        "dialCode": "+594"
    },
    {
        "countryCode": "GE",
        "dialCode": "+995"
    },
    {
        "countryCode": "GD",
        "dialCode": "+1-473"
    },
    {
        "countryCode": "GB",
        "dialCode": "+44"
    },
    {
        "countryCode": "GA",
        "dialCode": "+241"
    },
    {
        "countryCode": "SV",
        "dialCode": "+503"
    },
    {
        "countryCode": "GN",
        "dialCode": "+224"
    },
    {
        "countryCode": "GM",
        "dialCode": "+220"
    },
    {
        "countryCode": "GL",
        "dialCode": "+299"
    },
    {
        "countryCode": "GI",
        "dialCode": "+350"
    },
    {
        "countryCode": "GH",
        "dialCode": "+233"
    },
    {
        "countryCode": "OM",
        "dialCode": "+968"
    },
    {
        "countryCode": "TN",
        "dialCode": "+216"
    },
    {
        "countryCode": "JO",
        "dialCode": "+962"
    },
    {
        "countryCode": "HR",
        "dialCode": "+385"
    },
    {
        "countryCode": "HT",
        "dialCode": "+509"
    },
    {
        "countryCode": "HU",
        "dialCode": "+36"
    },
    {
        "countryCode": "HK",
        "dialCode": "+852"
    },
    {
        "countryCode": "HN",
        "dialCode": "+504"
    },
    {
        "countryCode": "HM",
        "dialCode": "+"
    },
    {
        "countryCode": "VE",
        "dialCode": "+58"
    },
    {
        "countryCode": "PR",
        "dialCode": "+1-787"
    },
    {
        "countryCode": "PR",
        "dialCode": "+1-939"
    },
    {
        "countryCode": "PS",
        "dialCode": "+970"
    },
    {
        "countryCode": "PW",
        "dialCode": "+680"
    },
    {
        "countryCode": "PT",
        "dialCode": "+351"
    },
    {
        "countryCode": "SJ",
        "dialCode": "+47"
    },
    {
        "countryCode": "PY",
        "dialCode": "+595"
    },
    {
        "countryCode": "IQ",
        "dialCode": "+964"
    },
    {
        "countryCode": "PA",
        "dialCode": "+507"
    },
    {
        "countryCode": "PF",
        "dialCode": "+689"
    },
    {
        "countryCode": "PG",
        "dialCode": "+675"
    },
    {
        "countryCode": "PE",
        "dialCode": "+51"
    },
    {
        "countryCode": "PK",
        "dialCode": "+92"
    },
    {
        "countryCode": "PH",
        "dialCode": "+63"
    },
    {
        "countryCode": "PN",
        "dialCode": "+870"
    },
    {
        "countryCode": "PL",
        "dialCode": "+48"
    },
    {
        "countryCode": "PM",
        "dialCode": "+508"
    },
    {
        "countryCode": "ZM",
        "dialCode": "+260"
    },
    {
        "countryCode": "EH",
        "dialCode": "+212"
    },
    {
        "countryCode": "EE",
        "dialCode": "+372"
    },
    {
        "countryCode": "EG",
        "dialCode": "+20"
    },
    {
        "countryCode": "ZA",
        "dialCode": "+27"
    },
    {
        "countryCode": "EC",
        "dialCode": "+593"
    },
    {
        "countryCode": "IT",
        "dialCode": "+39"
    },
    {
        "countryCode": "VN",
        "dialCode": "+84"
    },
    {
        "countryCode": "SB",
        "dialCode": "+677"
    },
    {
        "countryCode": "ET",
        "dialCode": "+251"
    },
    {
        "countryCode": "SO",
        "dialCode": "+252"
    },
    {
        "countryCode": "ZW",
        "dialCode": "+263"
    },
    {
        "countryCode": "SA",
        "dialCode": "+966"
    },
    {
        "countryCode": "ES",
        "dialCode": "+34"
    },
    {
        "countryCode": "ER",
        "dialCode": "+291"
    },
    {
        "countryCode": "ME",
        "dialCode": "+382"
    },
    {
        "countryCode": "MD",
        "dialCode": "+373"
    },
    {
        "countryCode": "MG",
        "dialCode": "+261"
    },
    {
        "countryCode": "MF",
        "dialCode": "+590"
    },
    {
        "countryCode": "MA",
        "dialCode": "+212"
    },
    {
        "countryCode": "MC",
        "dialCode": "+377"
    },
    {
        "countryCode": "UZ",
        "dialCode": "+998"
    },
    {
        "countryCode": "MM",
        "dialCode": "+95"
    },
    {
        "countryCode": "ML",
        "dialCode": "+223"
    },
    {
        "countryCode": "MO",
        "dialCode": "+853"
    },
    {
        "countryCode": "MN",
        "dialCode": "+976"
    },
    {
        "countryCode": "MH",
        "dialCode": "+692"
    },
    {
        "countryCode": "MK",
        "dialCode": "+389"
    },
    {
        "countryCode": "MU",
        "dialCode": "+230"
    },
    {
        "countryCode": "MT",
        "dialCode": "+356"
    },
    {
        "countryCode": "MW",
        "dialCode": "+265"
    },
    {
        "countryCode": "MV",
        "dialCode": "+960"
    },
    {
        "countryCode": "MQ",
        "dialCode": "+596"
    },
    {
        "countryCode": "MP",
        "dialCode": "+1-670"
    },
    {
        "countryCode": "MS",
        "dialCode": "+1-664"
    },
    {
        "countryCode": "MR",
        "dialCode": "+222"
    },
    {
        "countryCode": "IM",
        "dialCode": "+44-1624"
    },
    {
        "countryCode": "UG",
        "dialCode": "+256"
    },
    {
        "countryCode": "TZ",
        "dialCode": "+255"
    },
    {
        "countryCode": "MY",
        "dialCode": "+60"
    },
    {
        "countryCode": "MX",
        "dialCode": "+52"
    },
    {
        "countryCode": "IL",
        "dialCode": "+972"
    },
    {
        "countryCode": "FR",
        "dialCode": "+33"
    },
    {
        "countryCode": "IO",
        "dialCode": "+246"
    },
    {
        "countryCode": "SH",
        "dialCode": "+290"
    },
    {
        "countryCode": "FI",
        "dialCode": "+358"
    },
    {
        "countryCode": "FJ",
        "dialCode": "+679"
    },
    {
        "countryCode": "FK",
        "dialCode": "+500"
    },
    {
        "countryCode": "FM",
        "dialCode": "+691"
    },
    {
        "countryCode": "FO",
        "dialCode": "+298"
    },
    {
        "countryCode": "NI",
        "dialCode": "+505"
    },
    {
        "countryCode": "NL",
        "dialCode": "+31"
    },
    {
        "countryCode": "NO",
        "dialCode": "+47"
    },
    {
        "countryCode": "NA",
        "dialCode": "+264"
    },
    {
        "countryCode": "VU",
        "dialCode": "+678"
    },
    {
        "countryCode": "NC",
        "dialCode": "+687"
    },
    {
        "countryCode": "NE",
        "dialCode": "+227"
    },
    {
        "countryCode": "NF",
        "dialCode": "+672"
    },
    {
        "countryCode": "NG",
        "dialCode": "+234"
    },
    {
        "countryCode": "NZ",
        "dialCode": "+64"
    },
    {
        "countryCode": "NP",
        "dialCode": "+977"
    },
    {
        "countryCode": "NR",
        "dialCode": "+674"
    },
    {
        "countryCode": "NU",
        "dialCode": "+683"
    },
    {
        "countryCode": "CK",
        "dialCode": "+682"
    },
    {
        "countryCode": "XK",
        "dialCode": "+"
    },
    {
        "countryCode": "CI",
        "dialCode": "+225"
    },
    {
        "countryCode": "CH",
        "dialCode": "+41"
    },
    {
        "countryCode": "CO",
        "dialCode": "+57"
    },
    {
        "countryCode": "CN",
        "dialCode": "+86"
    },
    {
        "countryCode": "CM",
        "dialCode": "+237"
    },
    {
        "countryCode": "CL",
        "dialCode": "+56"
    },
    {
        "countryCode": "CC",
        "dialCode": "+61"
    },
    {
        "countryCode": "CA",
        "dialCode": "+1"
    },
    {
        "countryCode": "CG",
        "dialCode": "+242"
    },
    {
        "countryCode": "CF",
        "dialCode": "+236"
    },
    {
        "countryCode": "CD",
        "dialCode": "+243"
    },
    {
        "countryCode": "CZ",
        "dialCode": "+420"
    },
    {
        "countryCode": "CY",
        "dialCode": "+357"
    },
    {
        "countryCode": "CX",
        "dialCode": "+61"
    },
    {
        "countryCode": "CR",
        "dialCode": "+506"
    },
    {
        "countryCode": "CW",
        "dialCode": "+599"
    },
    {
        "countryCode": "CV",
        "dialCode": "+238"
    },
    {
        "countryCode": "CU",
        "dialCode": "+53"
    },
    {
        "countryCode": "SZ",
        "dialCode": "+268"
    },
    {
        "countryCode": "SY",
        "dialCode": "+963"
    },
    {
        "countryCode": "SX",
        "dialCode": "+599"
    },
    {
        "countryCode": "KG",
        "dialCode": "+996"
    },
    {
        "countryCode": "KE",
        "dialCode": "+254"
    },
    {
        "countryCode": "SS",
        "dialCode": "+211"
    },
    {
        "countryCode": "SR",
        "dialCode": "+597"
    },
    {
        "countryCode": "KI",
        "dialCode": "+686"
    },
    {
        "countryCode": "KH",
        "dialCode": "+855"
    },
    {
        "countryCode": "KN",
        "dialCode": "+1-869"
    },
    {
        "countryCode": "KM",
        "dialCode": "+269"
    },
    {
        "countryCode": "ST",
        "dialCode": "+239"
    },
    {
        "countryCode": "SK",
        "dialCode": "+421"
    },
    {
        "countryCode": "KR",
        "dialCode": "+82"
    },
    {
        "countryCode": "SI",
        "dialCode": "+386"
    },
    {
        "countryCode": "KP",
        "dialCode": "+850"
    },
    {
        "countryCode": "KW",
        "dialCode": "+965"
    },
    {
        "countryCode": "SN",
        "dialCode": "+221"
    },
    {
        "countryCode": "SM",
        "dialCode": "+378"
    },
    {
        "countryCode": "SL",
        "dialCode": "+232"
    },
    {
        "countryCode": "SC",
        "dialCode": "+248"
    },
    {
        "countryCode": "KZ",
        "dialCode": "+7"
    },
    {
        "countryCode": "KY",
        "dialCode": "+1-345"
    },
    {
        "countryCode": "SG",
        "dialCode": "+65"
    },
    {
        "countryCode": "SE",
        "dialCode": "+46"
    },
    {
        "countryCode": "SD",
        "dialCode": "+249"
    },
    {
        "countryCode": "DO",
        "dialCode": "+1-809"
    },
    {
        "countryCode": "DO",
        "dialCode": "+1-829"
    },
    {
        "countryCode": "DM",
        "dialCode": "+1-767"
    },
    {
        "countryCode": "DJ",
        "dialCode": "+253"
    },
    {
        "countryCode": "DK",
        "dialCode": "+45"
    },
    {
        "countryCode": "VG",
        "dialCode": "+1-284"
    },
    {
        "countryCode": "DE",
        "dialCode": "+49"
    },
    {
        "countryCode": "YE",
        "dialCode": "+967"
    },
    {
        "countryCode": "DZ",
        "dialCode": "+213"
    },
    {
        "countryCode": "US",
        "dialCode": "+1"
    },
    {
        "countryCode": "UY",
        "dialCode": "+598"
    },
    {
        "countryCode": "YT",
        "dialCode": "+262"
    },
    {
        "countryCode": "UM",
        "dialCode": "+1"
    },
    {
        "countryCode": "LB",
        "dialCode": "+961"
    },
    {
        "countryCode": "LC",
        "dialCode": "+1-758"
    },
    {
        "countryCode": "LA",
        "dialCode": "+856"
    },
    {
        "countryCode": "TV",
        "dialCode": "+688"
    },
    {
        "countryCode": "TW",
        "dialCode": "+886"
    },
    {
        "countryCode": "TT",
        "dialCode": "+1-868"
    },
    {
        "countryCode": "TR",
        "dialCode": "+90"
    },
    {
        "countryCode": "LK",
        "dialCode": "+94"
    },
    {
        "countryCode": "LI",
        "dialCode": "+423"
    },
    {
        "countryCode": "LV",
        "dialCode": "+371"
    },
    {
        "countryCode": "TO",
        "dialCode": "+676"
    },
    {
        "countryCode": "LT",
        "dialCode": "+370"
    },
    {
        "countryCode": "LU",
        "dialCode": "+352"
    },
    {
        "countryCode": "LR",
        "dialCode": "+231"
    },
    {
        "countryCode": "LS",
        "dialCode": "+266"
    },
    {
        "countryCode": "TH",
        "dialCode": "+66"
    },
    {
        "countryCode": "TF",
        "dialCode": "+"
    },
    {
        "countryCode": "TG",
        "dialCode": "+228"
    },
    {
        "countryCode": "TD",
        "dialCode": "+235"
    },
    {
        "countryCode": "TC",
        "dialCode": "+1-649"
    },
    {
        "countryCode": "LY",
        "dialCode": "+218"
    },
    {
        "countryCode": "VA",
        "dialCode": "+379"
    },
    {
        "countryCode": "VC",
        "dialCode": "+1-784"
    },
    {
        "countryCode": "AE",
        "dialCode": "+971"
    },
    {
        "countryCode": "AD",
        "dialCode": "+376"
    },
    {
        "countryCode": "AG",
        "dialCode": "+1-268"
    },
    {
        "countryCode": "AF",
        "dialCode": "+93"
    },
    {
        "countryCode": "AI",
        "dialCode": "+1-264"
    },
    {
        "countryCode": "VI",
        "dialCode": "+1-340"
    },
    {
        "countryCode": "IS",
        "dialCode": "+354"
    },
    {
        "countryCode": "IR",
        "dialCode": "+98"
    },
    {
        "countryCode": "AM",
        "dialCode": "+374"
    },
    {
        "countryCode": "AL",
        "dialCode": "+355"
    },
    {
        "countryCode": "AO",
        "dialCode": "+244"
    },
    {
        "countryCode": "AQ",
        "dialCode": "+"
    },
    {
        "countryCode": "AS",
        "dialCode": "+1-684"
    },
    {
        "countryCode": "AR",
        "dialCode": "+54"
    },
    {
        "countryCode": "AU",
        "dialCode": "+61"
    },
    {
        "countryCode": "AT",
        "dialCode": "+43"
    },
    {
        "countryCode": "AW",
        "dialCode": "+297"
    },
    {
        "countryCode": "IN",
        "dialCode": "+91"
    },
    {
        "countryCode": "AX",
        "dialCode": "+358-18"
    },
    {
        "countryCode": "AZ",
        "dialCode": "+994"
    },
    {
        "countryCode": "IE",
        "dialCode": "+353"
    },
    {
        "countryCode": "ID",
        "dialCode": "+62"
    },
    {
        "countryCode": "UA",
        "dialCode": "+380"
    },
    {
        "countryCode": "QA",
        "dialCode": "+974"
    },
    {
        "countryCode": "MZ",
        "dialCode": "+258"
    }
]